module.exports = __webpack_public_path__ + "img/20190820132907269.20847558.png";